import {CanMatchFn} from '@angular/router';

const allowedFixtureStates = new Set(['connect-enabled', 'invalid-required-property']);
const allowedFixturePaths = new Set(['/ai/functions/fixture']);

export function isFunctionGeneralSettingsVisualFixtureUrl(href: string): boolean {
  const url = new URL(href);
  const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);
  const fixtureState = url.searchParams.get('functionGeneralSettingsVisualFixture') || '';

  return isLocalHost && allowedFixturePaths.has(url.pathname) && allowedFixtureStates.has(fixtureState);
}

export const functionGeneralSettingsVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) return false;

  return isFunctionGeneralSettingsVisualFixtureUrl(window.location.href);
};
